
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 469.335 469.335"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M464.761 1.918a10.642 10.642 0 00-11.385-.51l-448 256a10.652 10.652 0 00-5.323 10.313 10.652 10.652 0 007.24 9.063l133.784 44.591 51.57 140.961a10.67 10.67 0 0010.01 7c.406 0 .823-.021 1.229-.073 2.882-.331 5.307-1.881 7.021-4.031l.104.083 75.891-95.328 104.391 34.797c1.104.375 2.24.552 3.375.552 1.917 0 3.823-.521 5.5-1.531a10.627 10.627 0 005.021-7.385l64-384a10.648 10.648 0 00-4.428-10.502zM36.678 264.095L391.616 61.266 146.532 300.714 36.678 264.095zm172.417 65.219a10.687 10.687 0 00-2.01 5.063l-9.635 78.979-35.729-97.656 208.615-203.813-161.241 217.427zm8.726 93.192l8.858-72.595 38.673 12.891-47.531 59.704zm168.378-41.901l-151.195-50.398L440.863 52.594l-54.664 328.011z"}})])
          )
        }
      }
    